import React from 'react'
import styles from './styles.scss'

export interface MapKey {
  groups: {
    id: string
    layout: string
    name: string
    name_short?: string
    color: string
    title: string
    locator: string
    image: string
  }[]
  circles?: boolean
  noCount?: boolean
}
export const MapKey = ({
  groups,
  circles = false,
  noCount = false
}: MapKey) => {
  // groups.sort((a, b) => {
  //   if (a.name < b.name) {
  //     return -1
  //   }
  //   if (a.name > b.name) {
  //     return 1
  //   }
  //   return 0
  // })
  console.log('______', styles)

  return (
    // <div className='ui text container'>
    <div className=' mapKeySegment'>
      {/* <div className='ui text container'> */}
      <div className='mapkey'>
        {groups.map((g, i) => {
          return (
            <div key={i} className='element'>
              {/* style={{ color: g.color }} */}
              {!circles && (
                <img src={require('images/map_icons_' + g.id + '.png')} />
              )}
              {circles && (
                <div className='circle' style={{ backgroundColor: g.color }} />
              )}
              <div className='name'>
                {g.name_short || g.name}
                {!noCount && <span>{g.count}</span>}{' '}
              </div>
            </div>
          )
        })}
      </div>
      {/* </div> */}
    </div>
  )
}
